import { render, staticRenderFns } from "./user-contact-list.vue?vue&type=template&id=3fd5b233&"
import script from "./user-contact-list.vue?vue&type=script&lang=js&"
export * from "./user-contact-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports